<template>
  <!-- 中企联络中心管理 -->
  <div class="page-container">
    <!-- 数据卡片 -->
    <div class="page-card">
      <!-- 搜索栏 -->
      <div class="page-card__header">
        <el-row>
          <el-col :span="4">
            <span>中企信息（共：{{ aSum }}）</span>
          </el-col>

          <el-col :span="6" :offset="12">
            <el-input v-model="input">
              <el-button slot="append" icon="el-icon-search" @click="serach"></el-button>
            </el-input>
          </el-col>
        </el-row>
      </div>
      <!-- 表格内容 -->
      <div class="page-card__body">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="ID" width="50"></el-table-column>

          <el-table-column prop="name" label="联系人名字"></el-table-column>
          <el-table-column prop="company" label="公司名称">
          </el-table-column>
          <el-table-column prop="position" label="职位">
          </el-table-column>
          <el-table-column prop="phone_number" label="手机号码">
          </el-table-column>
          <el-table-column prop="type" label="企业类型">
          </el-table-column>
          <el-table-column prop="address" label="地址">
          </el-table-column>
          <el-table-column prop="province" label="省">
          </el-table-column>
          <el-table-column prop="city" label="市">
          </el-table-column>

          <el-table-column prop="create_time" label="日期"></el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="deleteClick(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-wrap">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :total="aSum"
        :page-count="pageCount"
        :current-page.sync="currentPage"
        background
        layout="prev, pager, next,jumper"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from "../../../utils/api";

export default {
  name: "",
  data() {
    return {
      tableData: [],
      logoUrl: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/logo/",
      errorImg:
        "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/logo/2350b7a2a4e04ed7bb44b709b013df4520220806165014841596.jpg",
      input: '',
      //分页
      // 总条目数 total
      aSum: 0,
      // 当前页数 currenr_page
      currentPage: 1,
      // 总页数 num_pages
      pageCount: 1,
      // 每页显示条目数 pagesize
      pagesize: 10,
    };
  },
  mounted() {
    // 页面加载时获取企业信息
    this.getinfo();
  },
  methods: {
    // 获取企业联络信息列表
    getinfo() {
      let url = this.baseUrl + "/admin/liaison_center/?ordering=-date_joined";
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = 1;
      });
    },

    // 分页切换
    handleCurrentChange(val) {
      let url = this.baseUrl + "/admin/liaison_center/?ordering=-date_joined&page=" + val + "&name__icontains=" + this.input;
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = val;
      });
    },

    // 查看企业详情
    handleClick(row) {
      this.$router.push({
        name: "admin_exhibitorDetails",
        query: {id: row.id},
      });
    },

    // 删除企业信息
    deleteClick(row) {
      this.$confirm("将删除此条信息，是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let id = row.id;
        let url = this.baseUrl + "/admin/liaison_center/" + id + "/";
        api.deleteData(url).then((res) => {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.getinfo();
        });
      });
    },

    // 搜索企业信息
    serach() {
      let url = this.baseUrl + "/admin/liaison_center/?name__icontains=" + this.input;
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = 1;
      });
    },
  },
};
</script>

<style scoped>
::v-deep .el-input-group__append button.el-button {
  background-color: #42b983;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/tha_liaison/index.vue